export default __webpack_public_path__ + "static/media/logo.8c0cad65.png";